import ViolationsWidgets from './ViolationsWidgets';

export { type ViolationsWidgetMenuItemOption } from './ViolationsWidgetMenuItem';

export default ViolationsWidgets;
